import { DataQueryObject } from './data-query-object.model';
import { DataQueryCategory } from './data-query-category.model';
import { DataQueryFieldFilter } from './data-query-field-filter.model';
import { DataQueryTransformationField } from './data-query-transformation-field.model';
import { ErrorList } from '../../shared-components/controls/error-prompt/error-list.model';
import { ElementRef } from '@angular/core';
import { Lookup } from '../../shared-components/lookup/lookup.model';

export class DataQueryField {

	// Server Properties
	Alias: string;
	Break: string;
	CategoryID: number;
	CategoryName: string;
	ColumnName: string;
	ConstantValue: string;
	DataType: string;
	Deleted: boolean;
	DisplayName: string;
	Editable: boolean;
	Field: string;
	FieldName: string;
	FilterType: number;
	Filters: DataQueryFieldFilter[] = [];
	FunctionText: string;
	ID: number;
	IsCalculated: boolean;
	IsConstant: boolean;
	IsDefaultFilterField: boolean;
	IsDefaultStudentSearchFilter: boolean;
	IsDefaultCourseSearchFilter: boolean;
	IsDuplicate: boolean;
	IsStudentFilter: boolean;
	IsCourseFilter: boolean;
	IsTransErrorOpen: boolean;
	LookupIDColumnName: string;
	LookupTableName: string;
	LookupValueColumnName: string;
	LookupFilter: string;
	LookupProcedure: string;
	LookupParams: string;
	ObjectName: string;
	Permission: string;
	PreviewData = '';
	SQLColumnName: string;
	SQLTableName: string;
	ShowOnReport: boolean;
	SortDirection: string;
    SortOrder = -1;
    SortByDefault: boolean;
	StudentFilterId: number;
	CourseFilterId: number;
	TransformationFields: DataQueryTransformationField[] = [];
	TransformationFunction: string;
	Visible: boolean;
	IncludeInResults: boolean;
	ShowTimeForDates: boolean;
	UserDefinedTabId: number;
	FieldSize: number;
	// For Mass Edit
	FilterOptions: Lookup[] = [];
	// -------Used for editable custom layouts --------//
	Value: any;
	CustomLayoutFieldId: number;
	TemplateRef: ElementRef;
	Required: boolean;
	// ------- end Used for editable custom layouts --------//

	// Local Properties
	private _functionErrors: string[] = [];
	private _object: DataQueryObject;
	private _category: DataQueryCategory;
	errors: ErrorList[] = [];

	// Class Functions
	get nestedName(): string {
		return this.ObjectName + '.' + this.CategoryName + '.' + this.FieldName;
	}

	get FunctionError() {
		return this._functionErrors;
	}

	set FunctionError(value: string[]) {
		this._functionErrors = value;
		if (!value || value.length == 0) {
			this.errors = [];
		}
	}

	get object(): DataQueryObject {
		return this._object;
	}

	set object(value: DataQueryObject) {
		this._object = value;
		if (value) {
			this.ObjectName = value.ObjectName;
		}
	}

	get category(): DataQueryCategory {
		return this._category;
	}

	set category(value: DataQueryCategory) {
		this._category = value;
		if (value) {
			this.CategoryName = value.CategoryName;
		}
	}

	// Methods
	duplicate() {
		// POST: returns a duplicate of this object
		const newField = new DataQueryField();
		Object.assign(newField, this);
		newField.Filters = [];
		this.Filters.forEach(filter => {
			newField.Filters.push(filter.duplicate(newField));
		});
		return newField;
	}

	addFunctionError(error: string, reference?: ElementRef) {
		// POST: Adds the error to the FunctionErrors and also composes an ErrorList object
		this.FunctionError.push(error);
		this.errors.push({
			fieldName: '',
			errorMsg: error,
			fieldRef: reference
		});
	}
}
